import {
  FETCH_BIDS,
  FETCH_BIDS_SUCCESS,
  FETCH_BIDS_FAILED
} from '../../types';

const initialState = {
  bids: {},
  isLoading: false,
  errors: {},
  error: false
}

const fetchBidsReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_BIDS:
      return {
        ...state,
        isLoading: true,
          bids: action.payload
      }
      case FETCH_BIDS_SUCCESS:
        return {
          ...state,
          isLoading: false,
            bids: action.payload
        }
        case FETCH_BIDS_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchBidsReducer;
